import React, { useState, useEffect, useRef } from "react";
import { apiGet, apiPost } from "../../../utils/services";
import Select from "react-select";
import { IconButton, Grid,  Button, Paper} from "@mui/material";
import { Title, TextField} from "../../atoms";
import { FaBackspace } from "react-icons/fa";
import Modal from "react-responsive-modal";
import { Toaster, toast } from "react-hot-toast";
import { UPDATE_OPERATIONAL_ADDRESS, GET_OPERATIONAL_ADDRESS, GET_SUGGESTED_STREETS, GET_POSTALCODEBY_STREET } from "../../../api/apiConfig";
import { BiLoaderCircle } from "react-icons/bi";
import MapContainer from '../GoogleMap/MapContainer';

const OperationalAddressSettings = ({ handleSettingSwitch }) => {

const getOperationalAddress = async () => {
        
        

        const res = await apiGet(GET_OPERATIONAL_ADDRESS);
        if (res) {
            console.log(res.data);
           
           setOperationalAddress(res.data);   
           setCity(res.data?.city);  
            
           setStreet(res.data?.street);
           setPostalCode(res.data?.postalCode);
           console.log(res.data?.ukCities);
           setCityList(res.data?.ukCities);
           
           
        }
         
       
    };
    const handleCityChange = async (selectedOption) => {
      if(!selectedOption)
      {
        return;
      }
      console.log("selected city ",selectedOption.label);
     
      setCity(selectedOption.label);
      
    };

 const updateStreetList = async ()=> {

  if(!City) return;
  
    
    
  
  console.log("getting streets for ", City);
    const res = await apiGet(`${GET_SUGGESTED_STREETS}?city=${City}`);

    if(res)
    {
      setStreetList(res.data.suggestedStreets)
      console.log("retrieved strs ", res.data.suggestedStreets);
    }
 };
 const handleStreetInputChange =  (inputValue, { action }) => {
  console.log("action is", action);
  if (action === 'input-change' && inputValue.trim() !== '') 
  {
    const newOption = { label: inputValue, value: inputValue };
    
    setStreet(newOption.value);
    console.log("setting strt",newOption.value)
    getAutoCompleteList(newOption.value)
        .catch((error) => {
          console.error("Error fetching autocomplete list:", error);
        });

  }
  else{
    console.log("returning with no action");
    return;
  }
};
const handleOpenModal =()=>{
  setOpenModal(true);
};
const handleCloseModal =()=>{
 setOpenModal(false);
};

    const updateOperationalAddress = async ()=>{

      if(isLoading)
      {
        return;
      }
        setIsLoading(true);
        console.log(City + " " + Street);


        if(City == "" || Street == "" || PostalCode == "")
        {
            toast.error("Please fill all fields");
        }
        const res = await apiPost(UPDATE_OPERATIONAL_ADDRESS, {PostalCode : PostalCode, City: City, Street:Street});

        if(res)
        {
            toast.success("Operational Address Updated Successfully");
        }
        else
        {
            toast.error("Unable to update address");
        }
        handleCloseModal();
        setIsLoading(false);

    }; 
  

  const [operationalAddress, setOperationalAddress] = useState({});
  const [Street, setStreet] = useState("");
  const [City, setCity] = useState("");
  const [PostalCode, setPostalCode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [CityList, setCityList] = useState([]);
  const [StreetList, setStreetList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const[mapCenter, setMapCenter] = useState({ lat: 54.7024, lng: 3.2765})
   
  
  
const setPostalCodeByStreet = async () =>{
  const res = await apiGet(`${GET_POSTALCODEBY_STREET}?street=${Street}`);
  if(res)
  {
    console.log("opstal --", res)
    if(res.data !== null)
    {    
      if(res.data.postalCode != null || res.data.postalCode != '')
      {
      
      setPostalCode(res.data.postalcode);
      setMapCenter({lat: res.data.lat, lng: res.data.lng});
      console.log("map center", res.data.lat , res.data.lng);
      }

      if(res.data.postalCode === null || res.data.postalCode === '')
      {
        setPostalCode("");
        setMapCenter({ lat: 54.7024, lng: 3.2765});
      }
    }
    else{
      setPostalCode("");
        setMapCenter({ lat: 54.7024, lng: 3.2765});
    }

    
  }
};
  const getAutoCompleteList = (streetinput)=>{
    return apiGet(`https://localhost:44353/api/Account/AutoComplete?search=${streetinput}`)
    .then((res) => {
      if (res) {
        console.log("auto complete", res);
        if(res.data) setStreetList(res.data);
        
      }
    })
    .catch((error) => {
      console.error("Error fetching autocomplete list:", error);
    });
  };
  useEffect(() => {

    getOperationalAddress();
    console.log("operational address..." + operationalAddress);
  }, []);
useEffect(() => {
  const fetchData = async () => {
    await updateStreetList();
  };
  fetchData();
}, [City]);

useEffect( () => {
  const fetchData = async () => {
    await setPostalCodeByStreet();
    
  };
  fetchData();
  
}, [Street]);

const addressSelectRef = useRef();



  
  

  return (
    <div className="tabPanelCls h-100">
      <Toaster />
      <div
        className="dispatchTimer"
        style={{ position: "relative", marginTop: "20px" }}
      >
        <div
          style={{
            // position: "fixed",
           
            background: "white",
            marginTop: "10px",
          }}
        >
          <div className="header">
            <div style={{ marginBottom: 20 }}>
              <h2 className="ruby center">
                <IconButton onClick={() => handleSettingSwitch("")}>
                  <FaBackspace />
                </IconButton>
                Update Operational Address
              </h2>
            </div>
            </div>
<div className="mt-1 space-top" style={{ 
    
    
    alignItems: 'center', justifyContent: 'center', width: '100%' }}>
           <Paper className="padding2 space-top">
                <Grid item md={6} xs={12} container spacing={2} style={{ flexDirection: 'row', alignItems: 'center', alignItems: 'flex-start' }}>
                  {/* Form Section */}
                  <Grid item md={6} xs={12} style={{ textAlign: 'left' }}>
                    <div id="citySelection" style={{ marginTop: '32px' }}>
                      <Title text={"City/Town"} className="formLabelCls" />
                      <Select
                        placeholder={City ?? "Please input"}
                        onChange={handleCityChange}
                        options={CityList.map((m) => ({
                          value: m,
                          label: m,
                        }))}
                        value={City}
                        isSearchable={true}
                        isClearable={true}
                      />
                    </div>
                    <div id="streetSelection" style={{ marginTop: '32px' }}>
                      <Title text={"Street Address"} className="formLabelCls" />
                      <Select
                       ref={addressSelectRef}
                        placeholder={Street ?? "Please select"}
                        onInputChange={ (inputValue, { action }) => {
                           handleStreetInputChange(inputValue, { action });}}
                        onChange={(e) => setStreet(e.label)}
                        value={Street}
                        options={StreetList.map((m) => ({
                          value: m,
                          label: m,
                        }))}
                        isSearchable={true}
                      />
                    </div>
                    <div id="postalCodeSelection"  style={{ marginTop: '32px' }}>
                      <Title text={"Postal Code"} className="formLabelCls" />
                      <input
                        className="css-b62m3t-container"
                        style={{ width: '300px !important' }}
                        placeholder={PostalCode ?? "Please select"}
                        onChange={(e) => setPostalCode(e.target.value)}
                        value={PostalCode}
                      />
                    </div>
                  </Grid>

                  {/* Map Section */}
                  {/* <div className="desktopOnly" style={{paddingLeft: '70px', paddingTop: '30px'}}> */}
                  <Grid className="desktopOnly" item md={6} xs={12} style={{ textAlign: 'right', paddingLeft: '90px', paddingTop: '30px'}}>
                    <div>
                      {<MapContainer 
                      defaultCenter= {mapCenter}
                      title={Street}
                      containerStyles={{width: '700px', height: '300px', position: "unset !important", overflow: "unset !important"}}/>/* <MapContainer center={mapCenter} zoom={30} mapStyles ={{ width: '700px', height: '330px',}} /> */}
                    </div>
                  </Grid>
                  {/* </div> */}
                </Grid>

                <div className="space-top3">
                  <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />} variant="contained" sx={{ background: "#4E9D24" }} onClick={handleOpenModal}>
                    Update Address
                  </Button>
                  {/* <Button variant="contained" sx={{ background: "#000" }}>Cancel</Button> */}
                </div>
           </Paper>

           <div className="mobileOnly" style={{paddingLeft: '5px', paddingTop: '10px', alignContent: 'center',  flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                  <Grid item md={6} xs={12} style={{ textAlign: 'center'}}>
                  <div>
                      {<MapContainer 
                      defaultCenter= {mapCenter}
                      title={Street}
                      containerStyles={{width: '350px', height: '200px', position: "unset !important", overflow: "unset !important"}}/>/* <MapContainer center={mapCenter} zoom={30} mapStyles ={{ width: '700px', height: '330px',}} /> */}
                    </div>
                  </Grid>
             </div>
        
        </div>
          
        </div>
      </div>
      {ConfirmSubmit()}
    </div>
  );

  function ConfirmSubmit() {
    
    return (
        <Modal style={{ display: 'none !important',  width: '100%', overflowX: 'auto', overflowY: 'auto'}}
        open={openModal} showCloseIcon={true} center onClose={handleCloseModal}>
            <div className="padding">
                <div className="bold lg space-bottom2">Please confirm the info below</div>
               
                    <div className="space-top">
                      <label style={{ fontWeight: 'bold' }}>City/Town: </label> 
                      <label>{City}</label>                   
                        
                    </div>
                    <div className="space-top">
                      <label style={{ fontWeight: 'bold' }}>Street Address: </label>
                      <label>{Street}</label>
                    </div>
                    <div className="space-top">
                      <label style={{ fontWeight: 'bold' }}>Postal Code: </label>
                      <label>{PostalCode}</label>
                    </div>
                    <div className="space-top">
                      
                        <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />}
                                                    onClick={handleCloseModal}
                                                    variant="contained" color="secondary" 
                                                    style={{ marginRight: '20px' }}
                                                    >
                                                    Cancel
                                            </Button>
                     
                    
                        <Button startIcon={isLoading && <BiLoaderCircle sx={{ color: "#8D0C18" }} />}
                                                    onClick={() => updateOperationalAddress()}
                                                    variant="contained" color="secondary"
                                                    sx={{ background: "#4E9D24" }}>
                                                    Proceed
                                            </Button>
                       
                    </div>
                   
               
            </div>

        </Modal>
    )
};
};

export default OperationalAddressSettings;